import {InferType, boolean, object, string, number} from 'yup';
import {ValidationMessage} from '$constants/messages';
import {
  MEMBERSHIP_VALIDATION_REGEX,
  PRE_AUTH_CODE_REGEX,
} from '$constants/regex';
import {VALIDATION_MESSAGES} from '$modules/booking/components/PatientInsuranceDetailForm/constants';

export const patientInsuranceDetailFormSchema = object({
  selfPaying: boolean().required(ValidationMessage.SelectOption).nullable(),
  paymentMode: string()
    .transform(value => (isNaN(value) ? undefined : value))
    .nullable()
    .notRequired(),
  payment: object({
    id: string().nullable(),
    amount: number().nullable(),
    payment_method: string().nullable(),
  })
    .nullable()
    .notRequired(),
  insurance_claim: object({
    insurance_id: string().nullable(),
    membership_no: string()
      .nullable()
      .when('selfPaying', {
        is: false,
        then: schema =>
          schema
            .required(ValidationMessage.MembershipRequired)
            .matches(
              MEMBERSHIP_VALIDATION_REGEX,
              ValidationMessage.MembershipInvalid
            ),
        otherwise: schema => schema.notRequired(),
      }),
    pre_authorisation_code: string()
      .nullable()
      .notRequired()
      .transform(value => (value === '' ? undefined : value))
      .matches(
        PRE_AUTH_CODE_REGEX,
        VALIDATION_MESSAGES.PRE_AUTH_CODE_NUMBERS_ONLY
      )
      .optional(),
    insurer_name: string()
      .nullable()
      .when('selfPaying', {
        is: false,
        then: schema => schema.required(ValidationMessage.InsuranceRequired),
        otherwise: schema => schema.notRequired(),
      }),
  }).when('selfPaying', {
    is: false,
    then: schema => schema.required(ValidationMessage.InsuranceRequired),
    otherwise: schema => schema.notRequired(),
  }),
});

export type PatientInsuranceDetailFormData = InferType<
  typeof patientInsuranceDetailFormSchema
>;
